import {appStore as store} from '../index';

const attachToken = (httpConfig) => {
    let auth = store.getState();
    if(auth.auth.userDetails){
    if(auth.auth.userDetails.roleDetails.customer){
    httpConfig.headers['AMToken'] = store.getState() ? (store.getState().auth ? store.getState().auth.token : '' ) : '';
    httpConfig.headers['X-HSBC-GUID'] = store.getState() ? (store.getState().auth ? store.getState().auth.guid : '' ) : '';
    }
    else{
    httpConfig.headers['x-hsbc-e2e-trust'] = store.getState() ? (store.getState().auth ? store.getState().auth.token : '' ) : '';
    }
  }else {
   httpConfig.headers['x-hsbc-e2e-trust'] = store.getState() ? (store.getState().auth ? store.getState().auth.token : '' ) : '';
  }
}

const AuthInterceptor = {
  attachToken
}

export default AuthInterceptor;



// WEBPACK FOOTER //
// ./src/utils/AuthInterceptor.js